// extracted by mini-css-extract-plugin
module.exports = {"newsdetail-social":"NewsDetail_newsdetail-social__F4cnC","newsdetail-social-link":"NewsDetail_newsdetail-social-link__u0PqE"};